import { WindowBreakpoints } from '@dustin-web/microsite-config'
import classNames from 'classnames'
import Link from 'next/link'
import { useTranslations } from 'packages/microsite-components/src/hooks'
import { Icon } from 'packages/microsite-components/src/icon-library'
import { useTrackingOnScreen } from 'packages/microsite-components/src/on-screen'
import { DigitalData } from 'packages/microsite-components/src/utils/digital-data'

type Props = {
  breakpoints: WindowBreakpoints
}

export default function TakebackExtendedCard({ breakpoints }: Props) {
  const { translate } = useTranslations()
  const ref = useTrackingOnScreen(() => {
    DigitalData.pushViewPromotion({
      creative_name: 'takeback',
      promotion_name: 'filter-page_banner',
      creative_slot: 'service_icons',
      promotion_id: '',
    })
  })

  const onClick = (selectedService: string) => {
    DigitalData.pushSelectPromotion({
      promotion_id: '',
      creative_name: selectedService,
      promotion_name: 'filter-page_banner',
      creative_slot: 'service_icons',
    })
  }

  return (
    <article className="col-12 u-mb-8 u-mb-lg-16">
      <Link
        className="c-product-card c-product-card--list u-bg-dark-green u-color-light-green a-no-styling u-px-16 u-py-16"
        href={translate('Link_Takeback')}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => onClick('takeback')}>
        <div
          className={classNames('d-flex flex-column flex-lg-row gap-24', {
            'gap-40': breakpoints.min.LG,
          })}>
          <Icon
            className={classNames('i-72 u-color-green align-self-lg-center u-pl-lg-24', {
              'i-162': breakpoints.min.LG,
            })}
            name="leaf"
          />
          <div>
            <header ref={ref}>
              {breakpoints.min.LG ? (
                <>
                  <h2 className="h5 u-color-green u-pt-24">Takeback</h2>
                  <p className="h3">{translate('Takeback_Card_Subheader')}</p>
                </>
              ) : (
                <h2 className="h3 u-color-green">{translate('Takeback_Card_Subheader')}</h2>
              )}
            </header>
            <p className="u-fs-14 u-fs-lg-16 col-lg-9 u-pl-0">
              {translate('Takeback_Card_Information')}
            </p>
          </div>
        </div>
        <Icon className="i-24 align-self-end" name="arrow-right" />
      </Link>
    </article>
  )
}
